import { render, staticRenderFns } from "./MandatoryProperties.vue?vue&type=template&id=6c0f5138&scoped=true&"
import script from "./MandatoryProperties.vue?vue&type=script&lang=js&"
export * from "./MandatoryProperties.vue?vue&type=script&lang=js&"
import style0 from "./MandatoryProperties.vue?vue&type=style&index=0&id=6c0f5138&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0f5138",
  null
  
)

export default component.exports